import { useState } from "react";
import ReactGA from "react-ga";

const usePageTracking = () => {
  const [initialized, ] = useState(false);

  const trackEvent = (newEvent) => {
    if (initialized) {
      ReactGA.event(newEvent)
    }
  }

  return trackEvent
};

export default usePageTracking;
